const constants = {
    LOCALSTORAGE_AUTH_KEY: "__authed",
    LOCALSTORAGE_IS_ADMIN_KEY: "__admin",
    LOCALSTORAGE_LAST_LANG_KEY: "__lang",
    LOCALSTORAGE_JWT: "__token",
}

export default constants;